import { Box, Typography } from "@mui/material";
import WarningDialog from "components/WarningDialog";
import { useAppSelector } from "hooks/redux.hooks";
import React, { useState, useEffect, useRef } from "react";
import { selectTranslations } from "state/reducers/translation.reducers";
import { useMsal } from '@azure/msal-react';
import { logoutUser } from 'services/auth.service';

const LockScreen = () => {
  const t = useAppSelector(selectTranslations);
  const prefix = 'header.notifications.lock.screen.'
  const initialMinutes = 5
  const inactiveMinutes = t(prefix + 'minutes', '25')
  const [isLocked, setIsLocked] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState<number>(initialMinutes * 60);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const { instance, accounts } = useMsal();

  // Function to lock the screen
  const lockScreen = () => {
    setIsLocked(true);
  };

  // Function to reset the timer
  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(lockScreen, Number(inactiveMinutes) * 60 * 1000); // 5 minutes
  };

  // Format the time as MM:SS
  const formatTime = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  // Event listeners to reset timer on user activity
  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];
    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    // Set initial timer
    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isLocked) {
      if (secondsRemaining > 0) {
        const intervalId = setInterval(() => {
          setSecondsRemaining((prevSeconds) => prevSeconds - 1);
        }, 1000);

        // Clear interval on component unmount
        return () => clearInterval(intervalId);
      } else if (secondsRemaining === 0) {
        //logout user
        logoutUser(instance, accounts);
      }
    }
  }, [secondsRemaining, isLocked]);

  return (
    <WarningDialog
      open={isLocked}
      handleCancel={() => {
        setIsLocked(false)
        setSecondsRemaining(initialMinutes * 60)
        console.log('continue')
      }}
      handleContinue={() => {
        logoutUser(instance, accounts);
      }}
      title={prefix + 'title'}
      subTitle={prefix + 'subtitle'}
      cancelLabel={t(prefix + 'logout')}
      continueLabel={t(prefix + 'stay')}
    >
      <Typography variant="h3">{formatTime(secondsRemaining)}</Typography>
    </WarningDialog>
  );
};

export default LockScreen;
